import { render, staticRenderFns } from "./_page-betting-rules-kof.vue?vue&type=template&id=b6d99cce&lang=pug&"
import script from "./_page-betting-rules-kof.vue?vue&type=script&lang=js&"
export * from "./_page-betting-rules-kof.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports